import styled, { from, to } from 'theme';

export const HeaderNavWrapper = styled.nav`
  background-color: white;
  left: 0;
  position: relative;

  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  ul {
    padding: 0 1rem;

    background-color: white;
    border-bottom: ${props => props.theme.variables.borders.width.base} solid
      ${props => props.theme.variables.colors.silver};

    ${to('lg')} {
      padding-bottom: 5rem;
    }
  }

  li {
    text-transform: uppercase;
    border-top: ${props => props.theme.variables.borders.width.base} solid
      ${props => props.theme.variables.colors.silver};
    font-size: ${props => props.theme.variables.fonts.size.bigger0};

    a {
      display: block;
      padding: 0 2.5rem 0;
      line-height: 3.75rem;
      font-family: ${props => props.theme.variables.typography.secondaryFont};
      font-weight: ${props => props.theme.variables.fonts.weight.light};
      color: ${props => props.theme.variables.colors.black};

      &.header__nav-link--active {
        font-weight: ${props => props.theme.variables.fonts.weight.semiBold};
      }
    }
  }

  ${from('lg')} {
    ul {
      display: flex;
      border: 0;
      padding: 0 0.7rem;
    }

    li {
      border: 0;
      position: relative;

      a {
        line-height: 2.75rem;
        padding: 0 1.5rem 0;
        font-family: ${props => props.theme.variables.typography.secondaryFont};
        font-size: ${props => props.theme.variables.fonts.size.root};

        ${to('xlg')} {
          padding: 0 1rem 0;
        }

        &::after {
          display: block;
          bottom: 0.625rem;
          position: absolute;
          content: '';
          height: 0.125rem;
          width: 0%;
          background-color: ${props => props.theme.variables.customColors.leadingColor.base};
          transition: width 200ms ease-in-out;
        }

        &:hover,
        &.header__nav-link--active {
          &::after {
            width: 2.4rem;
          }
        }

        &.header__nav-link--active {
          font-weight: ${props => props.theme.variables.fonts.weight.semiBold};
        }
      }
    }
  }
`;
